import "../css/global.css";
import "../css/home.css";
import "../css/responsive.css";

import AndroidAppDrawer from "../../../components/AndroidAppDrawer";
import SignUpPrompt from "../../../components/SignUpPrompt";
import useIsLoggedIn from "../../../hooks/use-IsLoggedIn";
import LinkedInCallback from "../../Auth/SigninScreen/LinkedInCallback";
import Header from "../../Profile/components/Header";
import Footer from "../Footer";
import FeaturedEmployers from "./components/FeaturedEmployers";
import JobsByCategory from "./components/JobsByCategory";
import LatestJobs from "./components/LatestJobs";
import OverTheFold from "./components/OverTheFold";
import PreferencesUpsell from "./components/PreferencesUpsell";
import RecommendedJobs from "./components/RecommendedJobs";
import Resources from "./components/Resources";

function HomePage() {
	const isLoggedIn = useIsLoggedIn();

	return (
		<>
			<Header isLoggedIn={isLoggedIn} />
			<OverTheFold />
			<LatestJobs />
			<FeaturedEmployers />
			<JobsByCategory />
			<RecommendedJobs />
			<PreferencesUpsell />
			<Resources />
			<section className="bg-gray-900 pt-24 pb-16 px-4 md:px-8">
				<div className="max-w-4xl mx-auto text-center">
					<h2 className="!text-3xl !md:text-4xl !font-bold mb-4 !text-white font-plus-jakarta">
						Are you an employer looking for top talent?
					</h2>
					<p className="text-xl text-gray-400 opacity-80 mb-8 font-inter">
						Broaden your reach. Hire smarter. Dproz connects you with a diverse and qualified talent pool across
						Tanzania while simplifying your hiring process.
					</p>
					<a
						className="inline-block bg-primary-600 text-white px-8 h-10 leading-10 rounded-lg text-base font-medium hover:bg-primary-700 transition-colors font-inter"
						href="https://hiring.dproz.com/signup"
						target="_blank"
						rel="noreferrer"
					>
						Post Your Job Now
					</a>
				</div>
			</section>
			<Footer />
			<LinkedInCallback />
			<AndroidAppDrawer />
			<SignUpPrompt />
		</>
	);
}

export default HomePage;
